
import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useOperatorAuth } from '@/hooks/useOperatorAuth'
import { useSchools } from '@/hooks/useSchools'

const OperatorLoginForm = () => {
  const [isLogin, setIsLogin] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [selectedSchool, setSelectedSchool] = useState('')
  
  const { schools } = useSchools()
  const { loading, handleLogin, handleSignup } = useOperatorAuth()

  const handleAuth = async (e: React.FormEvent) => {
    e.preventDefault()

    if (isLogin) {
      await handleLogin(email, password)
    } else {
      await handleSignup(email, password, firstName, lastName, selectedSchool)
    }
  }

    return (
    <div className="w-full max-w-md">
        <Card className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_10px_40px_rgba(0,0,0,0.35)]">
          <CardHeader className="space-y-1">
            <div className="flex items-center justify-center mb-2">
              <img
                src="/dablylogofulltext-transparent.png"
                alt="Dably"
                className="h-10 w-auto drop-shadow-[0_4px_24px_rgba(34,197,94,0.35)]"
                loading="eager"
              />
            </div>

          </CardHeader>
        <CardContent>
          <form onSubmit={handleAuth} className="space-y-4">
          {!isLogin && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="firstName" className="text-white/80">First Name</Label>
                  <Input
                    id="firstName"
                    type="text"
                    placeholder="Enter first name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                    className="bg-black/30 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-green-400"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="lastName" className="text-white/80">Last Name</Label>
                  <Input
                    id="lastName"
                    type="text"
                    placeholder="Enter last name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                    className="bg-black/30 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-green-400"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="school" className="text-white/80">School</Label>
                <Select value={selectedSchool} onValueChange={setSelectedSchool} required>
                  <SelectTrigger className="bg-black/30 border-white/10 text-white focus-visible:ring-green-400">
                    <SelectValue placeholder="Select your school" />
                  </SelectTrigger>
                  <SelectContent>
                    {schools.map((school: any) => (
                      <SelectItem key={school.id} value={school.id}>
                        {school.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </>
          )}
          <div className="space-y-2">
            <Label htmlFor="email" className="text-white/80">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-black/30 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-green-400"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-white/80">Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="bg-black/30 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-green-400"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-green-500 hover:bg-green-400 text-white shadow-[0_6px_30px_rgba(34,197,94,0.4)]"
            disabled={loading}
          >
            {loading ? 'Processing...' : (isLogin ? 'Sign In' : 'Create Account')}
          </Button>
        </form>
        
        <div className="mt-4 text-center">
          <Button
            variant="link"
            onClick={() => setIsLogin(!isLogin)}
            className="text-sm text-green-300 hover:text-green-200"
          >
            {isLogin 
              ? "Don't have an account? Sign up" 
              : "Already have an account? Sign in"
            }
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
  )
}

export default OperatorLoginForm
